import React, { useState } from 'react'
import { useCssHandles } from '../hooks/useCssHandles'

const CSS_HANDLES = [
  'whatsappButton',
  'whatsappButtonContainer',
  'whatsappButtonIcon',
  'whatsappButtonPulse',
  'whatsappButtonTooltip',
  'whatsappButtonClose'
] as const

interface WhatsAppButtonProps {
  phoneNumber?: string
  message?: string
  className?: string
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ 
  phoneNumber = '551932552356',
  message = 'Olá! Gostaria de mais informações.',
  className = ''
}) => {
  const handles = useCssHandles(CSS_HANDLES)
  const [isHovered, setIsHovered] = useState(false)
  const [isVisible, setIsVisible] = useState(true)

  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message)
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
    window.open(whatsappUrl, '_blank')
  }

  if (!isVisible) return null

  return (
    <div className={`${handles.whatsappButtonContainer} fixed bottom-6 right-6 z-40 ${className}`}>
      {/* Tooltip */}
      {isHovered && (
        <div className={`${handles.whatsappButtonTooltip} absolute bottom-full right-0 mb-3 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg whitespace-nowrap transform transition-all duration-300 ease-out animate-in fade-in slide-in-from-bottom-2`}>
          <div className="relative">
            <span>Fale conosco no WhatsApp!</span>
            {/* Seta do tooltip */}
            <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      )}

      {/* Botão principal */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`${handles.whatsappButton} relative group bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 active:scale-95 focus:outline-none focus:ring-4 focus:ring-green-300`}
        aria-label="Falar no WhatsApp"
        title="Falar no WhatsApp"
      >
        {/* Efeito de pulso */}
        <div className={`${handles.whatsappButtonPulse} absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20`}></div>
        
        {/* Ícone do WhatsApp */}
        <div className={`${handles.whatsappButtonIcon} relative z-10 flex items-center justify-center w-full h-full`}>
          <svg 
            className="w-8 h-8" 
            fill="currentColor" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
        </div>

        {/* Efeito de hover - círculo externo */}
        <div className="absolute inset-0 rounded-full bg-green-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300 transform scale-150"></div>
      </button>

      {/* Botão de fechar (opcional) */}
      <button
        onClick={(e) => {
          e.stopPropagation()
          setIsVisible(false)
        }}
        className={`${handles.whatsappButtonClose} absolute -top-2 -left-2 w-6 h-6 bg-gray-500 hover:bg-gray-600 text-white rounded-full text-xs flex items-center justify-center transition-all duration-200 hover:scale-110 opacity-0 group-hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-gray-300`}
        aria-label="Fechar botão WhatsApp"
        title="Fechar"
      >
        ×
      </button>
    </div>
  )
}

export default WhatsAppButton

